export default __webpack_public_path__ + "static/artifact-b5d915e7dcf715cacf6e3d6dce2380b6.png";